import React from "react";
import Header from "../Header/Header";
import MainBody from "../MainBody/MainBody";

const Main = () => {
    return(
        <div className="main">
            <Header></Header>
            <MainBody></MainBody>
        </div>
    )
}

export default Main